module.exports = __webpack_public_path__ + "img/gm@2x.832018ef.png";